<template>
  <div v-if="showMqMessageData" class="maintenance-alarm">
    <div class="maintenance-alarm-content">
      <div class="maintenance-alarm-content__img">
        <img src="@/assets/img/maintenanceAlarm/mascot-fix.png"></img>
      </div>
      <div class="maintenance-alarm-content__title">
        {{ showMqMessageData.title }}
      </div>
      <div class="maintenance-alarm-content__message" v-html="showMqMessageData.message" />
      <div v-if="showMqMessageData.endAtUtc || showMqMessageData.startAtUtc" class="maintenance-alarm-content__time">
        {{ $t('Mq.MaintenanceTime') }}：
        <span v-if="showMqMessageData.startAtUtc">
          {{ formatDate(showMqMessageData.startAtUtc) }}
        </span>
        <span v-if="showMqMessageData.startAtUtc && showMqMessageData.endAtUtc"> - </span>
        <span v-if="showMqMessageData.endAtUtc">
          {{ formatDate(showMqMessageData.endAtUtc) }}
        </span>
      </div>
    </div>
    <div class="logo">
      <img src="@/assets/img/logo/logo@3x.png"></img>
    </div>
    <div class="maintenance-alarm-footer"></div>
  </div>
</template>

<script>
import { Sharer, sharedTypeMap } from '@/js/utils/shared'
import { MqMessage } from '@/js/utils/mqMessage/mqMessageClass'
export default {
  data () {
    return {
      mqNetworkInfo: {
        apiUrl: `${process.env.VUE_APP_MESSAGE_PROVIDER_URL}api/Provider/HousekeeperWeb/Message`,
        apiKey: process.env.VUE_APP_MESSAGE_PROVIDER_KEY,
        wsUrl: process.env.VUE_APP_MESSAGE_PROVIDER_WS_URL
      },
      mqMessageSharer: null,
      isSharerLeader: false,
      mqMessage: null,
      restartMqMessageCheckTimeout: null,
      comId: null,
      loginStatus: false,
      mqMessageData: []
    }
  },
  computed: {
    mqMessageSharerType () {
      return this.mqMessageSharer.type
    },
    showMqMessageData () {
      if (this.mqMessageData.length <= 0) return null
      const systemTopicMqMessageData = this.mqMessageData.filter((item) => item.topic === 'System')
      if (systemTopicMqMessageData && systemTopicMqMessageData.length > 0) return systemTopicMqMessageData[0]
      return this.mqMessageData[0]
    }
  },
  watch: {
    // 切分頁時檢查登入狀態以及 comId 是否改變
    $route: {
      handler () {
        this.getComId()
      }
    },
    comId () {
      if (this.mqMessageSharerType === sharedTypeMap.sharedWorker) {
        if (this.mqMessageSharer) this.mqMessageSharer.postMessage('setComId', { comId: this.comId })
      } else if (this.isSharerLeader) {
        // 終止輪詢及 ws，重來
        this.restartMqMessageCheck()
      }
    }
  },
  created () {
    this.getComId()

    this.connectSharer()
  },
  methods: {
    connectSharer () {
      this.mqMessageSharer = new Sharer('mqMessage')

      // 只有觸發 broadcastChannel & localStorage 會觸發
      this.mqMessageSharer.addEventListener('updateLeader', (e) => {
        // 我是 leader，由我掌管輪詢以及 ws，並同步資料
        this.isSharerLeader = e.detail?.isSelf || false
        if (e.detail?.isSelf) {
          this.startMqMessage()
        } else if (this.mqMessage) {
          this.mqMessage.terminationMqMessageCheck()
        }
      })
      // 都會觸發
      this.mqMessageSharer.addEventListener('updateData', (e) => {
        const { detail } = e
        this.mqMessageData = [...detail.data]
      })
      // 只有觸發 broadcastChannel 會觸發
      this.mqMessageSharer.addEventListener('pageJoin', (e) => {
        // 我是 leader 有頁面加入，我要同步資訊給大家
        if (this.isSharerLeader) this.mqMessageSharer.postMessage('syncData', this.mqMessageData)
      })

      // 如果連到 shared worker，則連線資訊交給 shared worker 處理
      if (this.mqMessageSharerType === sharedTypeMap.sharedWorker) {
        this.mqMessageSharer.postMessage('setNetworkInfo', this.mqNetworkInfo)
        this.mqMessageSharer.postMessage('setComId', { comId: this.comId })
        this.checkReload()
      } else if (this.isSharerLeader) {
        // 若為 broadcastChannel 或 localStorage，則由 leader 處理連線
        this.startMqMessage()
      }
    },
    checkReload () {
      // 如果頁面刷新，則終止輪詢及 ws，重新回到輪詢
      const navigationEntries = performance.getEntriesByType('navigation')
      const isReload = navigationEntries ? navigationEntries[0].type === 'reload' : false
      if (isReload) this.mqMessageSharer.postMessage('reload')
    },
    /**
     * 只有是 leader 時才需要執行，只有 broascastChannel 或 localStorage 才有可能，shared worker 時，leader 會是 shared worker，
     */
    startMqMessage () {
      this.mqMessage = new MqMessage()
      this.mqMessage.syncNetworkInfo(this.mqNetworkInfo.apiUrl, this.mqNetworkInfo.apiKey, this.mqNetworkInfo.wsUrl)
      this.mqMessage.startMqMessageCheck(this.comId)

      this.mqMessage.addEventListener('mqMessage', (event) => {
        if (Array.isArray(event.detail)) this.mqMessageData = [...event.detail]
        if (this.mqMessageData.length <= 0) {
          this.restartMqMessageCheck()
        }
        if (this.isSharerLeader) this.mqMessageSharer.postMessage('syncData', this.mqMessageData)
      })
    },
    /**
     * 重啟輪詢
     */
    restartMqMessageCheck () {
      if (!this.mqMessage) {
        this.startMqMessage()
        return
      }
      if (this.restartMqMessageCheckTimeout) {
        clearTimeout(this.restartMqMessageCheckTimeout)
        this.restartMqMessageCheckTimeout = null
      }
      this.mqMessage.terminationMqMessageCheck()
      // 延遲 5 秒後才重新開始輪詢，避免有訊息連發導致遺漏
      this.restartMqMessageCheckTimeout = setTimeout(() => {
        this.mqMessage.startMqMessageCheck(this.comId || null)
      }, 5 * 1000)
    },
    /**
     * 取得 comId，若與目前紀錄不同，則同步 shared worker
     */
    getComId () {
      const loginUserInfoJSON = localStorage.getItem('loginUserInfo')
      const loginStatusJSON = localStorage.getItem('loginStatus')
      if (!loginUserInfoJSON || !loginStatusJSON) return
      try {
        const loginStatusBool = JSON.parse(loginStatusJSON)
        this.loginStatus = loginStatusBool
        if (!loginStatusBool) {
          if (this.comId !== null) {
            this.comId = null
          }
          return
        }
        const loginUserInfo = JSON.parse(loginUserInfoJSON)
        // 過期被登出
        if (new Date() >= new Date(loginUserInfo.ExpireTime)) {
          if (this.comId !== null) {
            this.comId = null
          }
          return
        }
        if (this.comId !== loginUserInfo.ComId) {
          this.comId = loginUserInfo.ComId
        }
      } catch (e) {
        if (this.comId !== null) {
          this.comId = null
        }
      }
    },
    formatDate (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
.maintenance-alarm {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: $mqBackground;
  text-align: center;
  overflow-y: auto;

  img {
    vertical-align: middle;
  }

  .maintenance-alarm-content {
    margin: 145px auto 0;
    width: calc(100% - 18%);
    background-color: $white;
    padding-block: 40px 88px;
    min-height: calc(100vh - 145px - 40px - 88px - 208px - 36px);
    @media (max-width:1023px) {
      width: 70%;
      height: 100%;
      margin: 0;
      padding: 113px 15% 0;
    }

    .maintenance-alarm-content__img {
      img {
        width: 260px;
      }
    }
    .maintenance-alarm-content__title {
      margin-top: 30px;
      font-size: 48px;
      font-weight: 600;
      color: $fontColor;
    }
    .maintenance-alarm-content__message {
      margin-top: 30px;
      font-size: 32px;
      font-weight: normal;
      color: $subFontColor;
      line-height: 40px;
    }
    .maintenance-alarm-content__time {
      margin-top: 30px;
      font-size: 36px;
      color: $mainColor;
    }
  }

  .logo {
    padding-block: 80px;
    text-align: center;
    img {
      height: 48px;
    }
    @media (max-width:1023px) {
      display: none;
    }
  }

  .maintenance-alarm-footer {
    height: 36px;
    background-color: $mqFooter;
    @media (max-width:1023px) {
      display: none;
    }
  }
}
</style>
